import { SignInUrlBuilder } from '@tableau/shared-urls/lib/src/SignInUrlBuilder';
import React from 'react';

import { ServerSettingsUnauthenticated } from '~src/settings/services/ServerSettingsUnauthenticated';

import { IdentityPoolsLoginPage } from '../identityPools/login/IdentityPoolsLoginPage';
import { RootLoginUi } from '../Login/RootLoginUi';

export interface LoginPageStrategyProps {
    readonly routeLocationSearch: string;
}

export function LoginPageStrategy(props: LoginPageStrategyProps) {
    const signinQueryParams = SignInUrlBuilder.queryParamsFromQuery(props.routeLocationSearch);

    if (ServerSettingsUnauthenticated.isIdentityPoolsEnabled() && !signinQueryParams.isDefaultIdentityPoolLogin) {
        const errorCode = signinQueryParams.error ? signinQueryParams.error as number : 0;
        return <IdentityPoolsLoginPage errorCode={errorCode}/>;
    } else {
        return <RootLoginUi {...this.props} signinQueryParams={signinQueryParams}/>;
    }
}